import React, {Component} from "react";
import MomentDate from "../../../../components/MomentDate";
import EventHelper from "../../../../helpers/EventHelper";

class Event extends Component {
	state = {
		isDopOpen : false
	};

	toggleDop() {
		this.setState({
			isDopOpen : !this.state.isDopOpen
		});
	}

	render() {
		const {event, results} = this.props;
		const {team1, team2} = event;
		const result = EventHelper.parseResults(results);

		return (
			<div className="tbody">
				<div className="tr">
					<div className="td time">
						<MomentDate date={event.time} isLive={true}/>
					</div>
					<div className="td players">{team1} - {team2}</div>
					<div className="td score">{result.score}</div>
					<div className="td service">
						{result.hasOwnProperty('add') ?
							<div className="dop-dropdown" onClick={this.toggleDop.bind(this)}>
								<i className={`fas fa-chevron-down ${this.state.isDopOpen && 'rotate'}`}></i></div> : <div className="dop-dropdown">Нет</div>}
					</div>
				</div>

				{result.hasOwnProperty('add') && result.add.map((res) =>
					<div className={`tr dop ${this.state.isDopOpen && 'show'}`}>
						<div className="td time"></div>
						<div className="td players">{res.name}</div>
						<div className="td score">{res.value}</div>
						<div className="td service"></div>
					</div>
				)}
			</div>
		);
	}
}

export default Event;


// WEBPACK FOOTER //
// ./src/app/pages/Result/Line/modules/Event.js